import { Flex, FlexProps } from "@chakra-ui/react";
import isNil from "lodash/fp/isNil";
import { useTranslation } from "react-i18next";

import { OFText } from "design_system/components/OFText";
import { colors } from "src/colors";
import { formatPrice } from "src/utils/priceFormat";

type Props = FlexProps & { cashbackAmount: number };

export const CashbackMessage = ({ cashbackAmount, ...props }: Props) => {
  const { t } = useTranslation();

  if (isNil(cashbackAmount) || Number.isNaN(cashbackAmount)) return null;

  return (
    <Flex flexDir="column" w="100%" mb={4} gap={1} {...props}>
      <Flex justify="space-between">
        <OFText textStyle="body3" color={colors.black[900]}>
          {t("prescription_checkout:cashback_earn_rate_message")}
        </OFText>
        <OFText textStyle="body3" color={colors.black[900]}>
          {formatPrice(cashbackAmount)}
        </OFText>
      </Flex>
      <OFText textStyle="body4" color={colors.grey[900]}>
        {t("prescription_checkout:cashback_usage_message")}
      </OFText>
    </Flex>
  );
};
